import axios from "axios";
import Cookies from "js-cookie";
import * as types from "../mutation-types";
// console.log(Cookies.get('user'))
// state

function getUserLevel(userInfo) {
  var res = {};
  res["fe"] = false;
  res["fe2"] = false;
  res["oto1"] = false;
  res["oto1e"] = false;
  res["oto2"] = false;
  res["oto3"] = false;
  res["oto4"] = false;
  res["admin"] = false;
  if (userInfo && userInfo.level) {
    let levels = userInfo.level.split(",");
    levels.forEach((lvl) => {
      const l = lvl.toUpperCase();
      if (l == "FE") {
        res["fe"] = true;
      } else if (l == "FE2") {
        res["fe2"] = true;
      } else if (l == "OTO1") {
        res["oto1"] = true;
      } else if(l == 'OTO1E') {
        res["oto1e"] = true;
      } else if (l == "OTO2") {
        res["oto2"] = true;
      } else if (l == "OTO3") {
        res["oto3"] = true;
      } else if (l == "OTO4") {
        res["oto4"] = true;
      } else if( l == 'ADMIN') {
        res['admin'] = true;
      }
    });
  }

  return res;
}
let userc = localStorage.getItem("user");
const state = {
  user: "undefined" == typeof userc ? null : JSON.parse(localStorage.getItem("user")),
  userLevel: "undefined" == typeof userc ? [] : getUserLevel(JSON.parse(localStorage.getItem("user"))),
  token: Cookies.get("token"),
  brand: "default",
};
// getters
const getters = {
  brand: (state) => state.brand,
  user: (state) => state.user,
  userLevel: (state) => state.userLevel,
  token: (state) => state.token,
  check: (state) => state.user !== null,
};

// mutations
const mutations = {
  [types.SAVE_BRAND](state, brand) {
    state.brand = brand;
  },

  [types.SAVE_TOKEN](state, { token, remember }) {
    state.token = token;
    Cookies.set("token", token, { expires: 30 });
  },

  [types.FETCH_USER_SUCCESS]({ user }) {
    state.user = user;
    state.userLevel = getUserLevel(user);
  },

  [types.FETCH_USER_FAILURE](state) {
    state.token = null;
    state.user = null;
    state.userLevel = [];
    Cookies.remove("token");
    localStorage.removeItem("user");
  },

  [types.LOGOUT](state) {
    state.token = null;
    state.user = null;
    state.userLevel = [];
    Cookies.remove("token");
    localStorage.removeItem("user");
  },

  [types.UPDATE_USER](state, { user }) {
    state.user = user;
    state.userLevel = getUserLevel(user);
    localStorage.setItem("user", JSON.stringify(user));
  },
};

// actions
const actions = {
  storeBrand({ commit }, payload) {
    commit(types.SAVE_BRAND, payload);
  },
  saveToken({ commit, dispatch }, payload) {
    commit(types.SAVE_TOKEN, payload);
  },

  async fetchUser({ commit }) {
    try {
      const { data } = await axios.get("/api/user");
      commit(types.FETCH_USER_SUCCESS, { user: data });

      commit(types.UPDATE_USER, { user: data });
    } catch (e) {
      commit(types.FETCH_USER_FAILURE);
    }
  },

  updateUser({ commit }, payload) {
    commit(types.UPDATE_USER, payload);
  },

  async logout({ commit }) {
    try {
      await axios.post("/api/logout");

      Cookies.remove("token");
      localStorage.removeItem("user");
    } catch (e) {}

    commit(types.LOGOUT);
  },

  async fetchOauthUrl(ctx, { provider }) {
    const { data } = await axios.post(`/api/oauth/${provider}`);

    return data.url;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/auth.js